var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"intro-content"},[_c('div',{staticClass:"intro-detail-title"},[_vm._v(_vm._s(_vm.data.subTitle)+"玩法规则")]),_c('keep-alive',[_c(_vm.data.content,{tag:"component",staticClass:"intro-detail-content"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }